import React from "react";

const border_style = {
  gold: "gold-border rounded-[4px] p-[1px] ",
  silver: "silver-border rounded-[4px] p-[1px]",
  bronze: "bronze-border rounded-[4px] p-[1px] ",
  action_required: "border-[1px] border-[#F4AA26] text-[#F4AA26] rounded-full",
  verified: "border-[1px] border-[#3BB800] text-[#3BB800] rounded-full",
  requested: "border-[1px] border-[#4361EE] text-[#4361EE] rounded-full",
  under_verification:
    "border-[1px] border-[#C17526] text-[#C17526] rounded-full",
  not_verified: "border-[1px] border-[#C90202] text-[#C90202] rounded-full",
  sent_for_approval:
    "border-[1px] border-[#00DFAC] text-[#00DFAC] rounded-full",
  "in-process": "border-[#00BD9B] border-2 rounded-full",
  completed: "border-[#3BB800] border-2 rounded-full",
  refused: "border-[#F4AA26] border-2 rounded-full",
  cancelled: "border-[#C90202] border-2 rounded-full",
  "request canceled": "border-[#C90202] border-2 rounded-full",
  "bid accepted": "border-[1px] border-[#00DFAC] text-[#00DFAC] rounded-full",
  "document uploaded":
    "border-[1px] border-[#828282] text-[#828282] rounded-full",
  "in-holding": "border-[1px] border-yellow-500 text-yellow-500 rounded-full",
  "payment completed":
    "border-[1px] border-yellow-500 text-yellow-500 rounded-full",
  "action required":
    "border-[1px] border-[#C17526] text-[#C17526] rounded-full",
  "document upload link expires":
    "border-[1px] border-[#F4AA26] text-[#F4AA26] rounded-full",
  "payment link expired": "border-2 border-red-500 text-red-500 rounded-full",
  "transaction completed":
    "border-[1px] border-[#4361EE] text-[#4361EE] rounded-full",
  "response recieved":
    "border-[1px] border-[#C17526] text-[#C17526] rounded-full",
  "transaction canceled": "border-[#C90202] border-2 rounded-full",
  "deposited" : "border-[#00BD9B] border-2 rounded-full",
  "documents upload link expires": "border-2 border-red-500 text-red-500 rounded-full",
  "not-completed" : "border-[#C90202] border-2 rounded-full",
  "push_to_finance":"border-[#00BD9B] border-2 rounded-full",
  "response received": "border-[1px] border-purple-600 text-purple-600 rounded-full"
};

const background_style = {
  gold: "bg-gold-gradient rounded-[3px]",
  silver: "bg-silver-gradient rounded-[3px]",
  bronze: "bg-bronze-gradient rounded-[3px]",
  action_required: "bg-[#F4AA2626] rounded-full",
  verified: "bg-[#3BB80026] rounded-full",
  requested: "bg-[#4361EE26] rounded-full",
  under_verification: "bg-[#C1752626] rounded-full",
  not_verified: "bg-[#C9020226] rounded-full",
  sent_for_approval: "bg-[#00DFAC26] rounded-full",
  "bid accepted": "bg-[#00DFAC26] rounded-full text-teal-500 font-medium",
  "in-process": "bg-[#00BD9B26] rounded-full text-[#00BD9B] font-medium",
  completed: "bg-[#3BB80026] rounded-full text-[#3BB800] font-medium",
  refused: "bg-[#F4AA2626] rounded-full text-[#F4AA26] font-medium",
  cancelled: "bg-[#C9020226] rounded-full text-[#C90202] font-medium",
  "request canceled": "bg-[#C9020226] rounded-full text-[#C90202] font-medium",
  "document uploaded": "bg-[#82828226] rounded-full",
  "in-holding": "bg-yellow-50  bg-opacity-15 rounded-full",
  "payment completed": "bg-yellow-50  bg-opacity-15 rounded-full",
  "action required": "bg-yellow-800  bg-opacity-30  rounded-full",
  "document upload link expires": "bg-[#F4AA2626] rounded-full",
  "payment link expired": "bg-red-100  bg-opacity-15 rounded-full",
  "transaction completed": "bg-[#4361EE26] rounded-full",
  "response recieved": "bg-[#C1752626] rounded-full",
  "transaction canceled": "bg-[#C9020226] rounded-full text-[#C90202] font-medium",
  "deposited" : "bg-[#00BD9B26] rounded-full text-[#00BD9B] font-medium",
  "documents upload link expires" : "bg-red-100  bg-opacity-15 rounded-full py-1",
  "not-completed" : "bg-[#C9020226] rounded-full text-[#C90202] font-medium",
  "push_to_finance":"bg-[#00BD9B26] rounded-full text-[#00BD9B] font-medium",
  "response received": "bg-purple-200 rounded-full",
};

const Badge = ({ children, varient = "default" }) => {
  return (
    <div className={`w-fit ${border_style[varient?.toLowerCase()]}`}>
      <div
        className={` capitalize ${background_style[varient?.toLowerCase()]}`}
      >
        {children}
      </div>
    </div>
  );
};

export default Badge;
